export const CHANGE_LANGUAGE = "CHANGE_LANGUAGE";



export const changeLanguage = () => ({
  type: CHANGE_LANGUAGE,

});